import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {StudentTicketActiveChangeDto} from "../../../models/student-ticket/change/StudentTicketActiveChangeDto";
import {StudentTicketChangeType} from "../../../models/student-ticket/change/StudentTicketChangeType";
import {HttpHeaderService} from "../../utils/http/http-header.service";

@Injectable({
  providedIn: 'root'
})
export class StudentTicketChangeListService {

  configUrl = 'api/student-ticket-change-list';

  constructor(
    private readonly http: HttpClient,
    private readonly headerService: HttpHeaderService
  ) {}

  // checks whether a ticket has an active change of the given type
  hasTicketActiveChangeForType(uuid: string, changeType: StudentTicketChangeType): Observable<StudentTicketActiveChangeDto> {
    const dto = { changeType: changeType };
    return this.http.post<StudentTicketActiveChangeDto>(`${this.configUrl}/` + uuid + '/has-active-change', dto, {headers: this.headerService.getAuthHeader()});
  }
}
